import React from 'react';
import { Target, Briefcase, Zap, CheckSquare, ArrowUpRight } from 'lucide-react';
import { cn } from '@/shared/utils/utils';

interface PersonalKpiRowProps {
  myLeadsCount?: number;
  myDealsCount?: number;
  leadsTodayCount?: number;
  tasksOpenCount?: number;
}

export const PersonalKpiRow: React.FC<PersonalKpiRowProps> = ({
  myLeadsCount = 0,
  myDealsCount = 0,
  leadsTodayCount = 0,
  tasksOpenCount = 0,
}) => {
  const kpis = [
    {
      label: 'My leads',
      value: myLeadsCount,
      trend: 'All-time, assigned to you',
      icon: Target,
      color: 'text-primary',
      bgColor: 'bg-primary-container',
    },
    {
      label: 'My open deals',
      value: myDealsCount,
      trend: 'Currently open',
      icon: Briefcase,
      color: 'text-primary',
      bgColor: 'bg-primary-container',
    },
    {
      label: 'Leads today',
      value: leadsTodayCount,
      trend: leadsTodayCount > 0 ? 'New today' : 'None yet today',
      trendPositive: leadsTodayCount > 0,
      icon: Zap,
      color: 'text-info-text',
      bgColor: 'bg-info/10',
    },
    {
      label: 'Open tasks',
      value: tasksOpenCount,
      trend: tasksOpenCount === 0 ? 'No pending tasks' : `${tasksOpenCount} due`,
      icon: CheckSquare,
      color: 'text-warning-text',
      bgColor: 'bg-warning/10',
    },
  ];

  return (
    <div className="mb-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
      {kpis.map((kpi, idx) => {
        const Icon = kpi.icon;
        return (
          <div
            key={idx}
            className="flex flex-col gap-1 rounded-card border border-border bg-card p-4 shadow-xs"
          >
            <div className="flex items-start justify-between gap-2">
              <span className="font-mono text-data-lg font-semibold tabular-nums text-on-surface">{kpi.value}</span>
              <span className={cn('flex h-6 w-6 shrink-0 items-center justify-center rounded-lg', kpi.bgColor, kpi.color)} aria-hidden>
                <Icon className="h-3.5 w-3.5" />
              </span>
            </div>
            <span className="truncate text-body-sm text-on-surface-variant">{kpi.label}</span>
            <span className={cn('flex items-center gap-1 text-data-xs', kpi.trendPositive ? 'text-success-text' : 'text-on-surface-subtle')}>
              {kpi.trendPositive && <ArrowUpRight className="h-3 w-3" aria-hidden />}
              {kpi.trend}
            </span>
          </div>
        );
      })}
    </div>
  );
};
